import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TabsProps } from 'antd';

import { LenderBdmsSection, LenderDetailsSection, LenderProcurationFeesSection, LenderRegionsSection } from '@pmp/components';
import { Page, StyledTabs } from '@ohpen/enso-ui';

import styles from './styles.module.css';

export const LenderPage = (): ReactElement => {
  const { t } = useTranslation();

  const tabItems: TabsProps['items'] = useMemo(() => {
    const items = [
      {
        key: 'details',
        label: t('lender.lender.labels.complianceConfiguration'),
        children: <LenderDetailsSection />,
      },
      {
        key: 'procuration-fees',
        label: t('lender.lender.labels.defaultProcurationFees'),
        children: <LenderProcurationFeesSection />,
      },
      {
        key: 'regions',
        label: t('lender.regionsBdms.labels.regions'),
        children: <LenderRegionsSection />,
      },
      {
        key: 'bdms',
        label: t('lender.regionsBdms.labels.bdms'),
        children: <LenderBdmsSection />,
      },
    ];

    return items;
  }, [t]);

  return (
    <Page>
      <Page.Title>{t('lender.lender.title')}</Page.Title>
      <Page.Content>
        <StyledTabs defaultActiveKey="details" items={tabItems} className={styles.tabs} />
      </Page.Content>
    </Page>
  );
};
